export default function isActiveChartMarkerStock(activeStockId, stockId) {
  return activeStockId == null || activeStockId === stockId;
}
